import {
  FilterMode,
  UserWidgetConfigCreateMutationVariables,
  UserWidgetConfig_OrderBy,
  UserWidgetConfig,
  SortOrder,
  UserWidgetConfig_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const userWidgetConfigService = {
  createOne: buildCreateOne(
    (
        userWidgetConfigCreateVariables: UserWidgetConfigCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.userWidgetConfigCreate(
          userWidgetConfigCreateVariables
        );
        return result.userWidgetConfigCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.userWidgetConfigOne({ id });
    return result.userWidgetConfigOne as UserWidgetConfig;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: UserWidgetConfig_OrderBy[] | null = null,
    filter: UserWidgetConfig_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: UserWidgetConfig_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.userWidgetConfigListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.userWidgetConfigListWithOffset
    ) as UserWidgetConfig[];
    return { list, orderBy };
  },
};
